<script lang="ts">
	interface Props {
		title: string | null;
		subtitle: string | null;
	}

	let { title, subtitle }: Props = $props();
</script>

{#if title || subtitle}
	<div class="step-section-header">
		<h3 class="step-section-title">
			{title}
		</h3>
		{#if subtitle}
			<div class="step-section-subtitle">
				{subtitle}
			</div>
		{/if}
	</div>
{/if}
